module.exports = __webpack_public_path__ + "img/googleplay-tra-grey.6232c198.png";